
<template>
    <div class="info" >
         <div class="lytime">
            <img src="../assets/icon/loading.gif" alt="">
            <p>Loading...</p>
        </div>
    </div>
</template>
<script>
    export default{
        name:'salesList',
        components:{
           
        },
        data(){
            return{
                
            }
        },
        created(){
            
        },  
        methods:{
        }
    };
</script>
<style lang="scss" scoped>
    .info{
        position:fixed;
        width:100%;
        height:100%;
        background:rgba(0,0,0,.5);
        z-index:1005;
        left:0;
        top:0;
    }
    .lytime{
        width:200px;
        height:70px;
        border-radius: 15px;
        position:fixed;
        left:50%;
        top:50%;
        margin-left:-100px;
        margin-top:-100px;
        text-align: center;
        background:rgba(0,0,0,.5);
        z-index:1008;
        color:#fff;
        padding-top:130px;
        img{
          width:70px;
          height:70px;
          position: absolute;
          top:40px;
          left:65px;
        }
        p{
            color: #fff;
            font-size:22px;
        }
    }
</style>


